export const TOOLTIP_TOP_LEFT_POSITION_PERCENT = 4.3;
export const TOOLTIP_TOP_RIGHT_POSITION_PERCENT = 90;
